//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, NewsPostIconEnum } from './Enums';

export class TestNewsInputItem extends ItemBase {
    TeacherIndex: number = 0;
    PublishDate: string | null = null;
    Title: string | null = null;
    Body: string | null = null;
    Color: EventColorEnum | null = null;
    Icon: NewsPostIconEnum | null = null;
    Category: string | null = null;

    constructor(initializer?: Partial<TestNewsInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestNewsInputItem";
}
